export const ALL = 'all';
export const OPEN = 'open';
export const COMPLETED = 'completed';
export const CANCELED = 'canceled';
